/**
 * Displays an address form when travel rule is triggered and the user must enter
 * in a new address. This happens when a user's only address(es) on file is (are)
 * PO Box address(es). In order for a travel rule-triggered transaction to proceed,
 * they must enter a new, non-PO box address.
 */

import PropTypes from 'prop-types'

import React from 'react'
import { StyleSheet, css } from 'lib/paypalphrodite'
import glamorous from 'glamorous'
import AddressEntryField from 'react-address-entry-field'
import * as AddressActions from '../actions/address'
import { hasPOBox, isCityPOBox } from '../utils/travelRuleUtils'
import content from 'pp-react-l10n'
let i18n = content('transfer/send/identityInfo')

const STYLES = StyleSheet.create({
  label: {
    width: '100%',
    margin: '6px 0',
    display: 'inline-block',
    fontWeight: 'bold',
  },
})

const TravelRuleAddressBadge = glamorous.div({
  '& .col-sm-12': {
    paddingLeft: 0,
    paddingRight: 0,
  },
  '& .col-sm-8': {
    padding: '0 2% 0 0',
  },
  '& .col-sm-4': {
    paddingRight: 0,
  },
})

class TravelRuleAddress extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    country: PropTypes.string.isRequired,
    addressEntryFormat: PropTypes.object.isRequired,
    newTravelRuleAddress: PropTypes.object.isRequired,
    attemptedSubmit: PropTypes.bool.isRequired,
  }

  state = {
    hasPostcodeError: false,
  }

  handleTravelRuleAddressPostcodeHasError = hasPostcodeError => {
    this.setState({ hasPostcodeError })
  }

  handleChangeTravelRuleAddressField = (field, value) => {
    this.props.dispatch(
      AddressActions.changeTravelRuleAddressEntryField(field, value)
    )
  }

  getErrorMessage = field => {
    const { attemptedSubmit, newTravelRuleAddress } = this.props
    const shouldShowInvalidError =
      attemptedSubmit && !newTravelRuleAddress[field]
    switch (field) {
      case 'line1':
        if (hasPOBox(newTravelRuleAddress[field])) {
          return i18n('error.poBox')
        } else if (shouldShowInvalidError) {
          return i18n('error.invalid')
        }
      case 'line2':
        if (hasPOBox(newTravelRuleAddress[field])) {
          return i18n('error.poBox')
        }
        return
      case 'city':
        if (isCityPOBox(newTravelRuleAddress[field])) {
          return i18n('error.poBox')
        } else if (shouldShowInvalidError) {
          return i18n('error.invalid')
        }
      default:
        if (shouldShowInvalidError) {
          return i18n('error.invalid')
        }
    }
  }

  render() {
    const {
      addressEntryFormat,
      addressEntryFormat: { strings: labels },
    } = this.props
    const fields = addressEntryFormat.layout.filter(
      field => field._ !== undefined
    )

    return (
      <div>
        <label className={css(STYLES.label)}>
          {i18n('identityInfo.noPOAddress')}
        </label>
        <div style={{ marginTop: -10 }}>
          {fields.map(field => (
            <TravelRuleAddressBadge key={`travelRule_${field.$}`}>
              <AddressEntryField
                value={this.props.newTravelRuleAddress[field.$]}
                key={`travelRule_${field.$}`}
                {...field}
                id={`travelRule_${field.$}`}
                errorMessage={this.getErrorMessage(field.$)}
                country={this.props.country}
                fieldName={field.$}
                labels={labels}
                className="TestPadding"
                handleChangeField={this.handleChangeTravelRuleAddressField}
                handlePostcodeHasError={
                  this.handleTravelRuleAddressPostcodeHasError
                }
              />
            </TravelRuleAddressBadge>
          ))}
        </div>
      </div>
    )
  }
}

export default TravelRuleAddress
